import { create } from 'zustand';
// import { apiRequest } from '../utils/requestMethods'; // make sure this is imported correctly

import apiRequest from './apiRequest.js'; // Ensure this path is correct


export const useNotificationStore = create((set) => ({
  number: 0,
  fetch: async () => {
    try {
      const res = await apiRequest.get('/users/notification', {
        withCredentials: true, // instead of `credentials: 'include'` in fetch
      });
      set({ number: res.data.unseen });
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  },
  increase: () => {
    set((prev) => ({
      number: prev.number + 1,
    }));
  },
  decrease: () => {
    set((prev) => ({
      number: prev.number - 1,
    }));
  },
  reset: () => {
    set(() => ({
      number: 0,
    }));
  }
}));









// import {create} from 'zustand'

// // In notificationStore.js
// export const useNotificationStore = create((set) => ({
//     number: 0,
//     fetch: async () => {
//         const res = await fetch('/8800/api/users/notification', {
//             method: 'GET',
//             credentials: 'include',
//         });
//         const data = await res.json();
//         set({ number: data.unseen });
//     },
//     increase: () => {
//         set((prev) => ({
//             number: prev.number + 1
//         }));
//     },
//     decrease: () => {
//         set((prev) => ({
//             number: prev.number - 1
//         }));
//     },
//     reset: () => {
//         set(() => ({
//             number: 0
//         }));
//     }
// }));
